import { Grid, Typography, Box, MuiIcons } from "@leap4/frontend";
import {isToday} from "date-fns";
import React from "react";
import {ISellerJson} from "./seller.interface";
import {dateToStringFormat} from "../../utils/functions";
const { CheckCircle: CheckCircleIcon, Cancel: CancelIcon, CalendarToday: CalendarTodayIcon } = MuiIcons;


const parseDateSafely = (dateValue: string | Date | undefined | null): Date | null => {
  if (!dateValue) return null;
  if (dateValue instanceof Date) return dateValue;
  const parsed = new Date(dateValue);
  return isNaN(parsed.getTime()) ? null : parsed;
};

const SellerPageHeader = ({ currentSeller, title, action}: {siteDomainName: string, currentSeller?: ISellerJson, title: string, action?: React.ReactNode}) => {

    return (
        <Grid container rowGap={2} marginBottom={5}>
            <Grid item xs={12}>
                <Typography variant="h5" align="center">
                    {title}
                </Typography>
            </Grid>
            {currentSeller && (<>
            <Grid item xs={12}>
                <Box display="flex" alignItems="center">
                    {currentSeller.isValidate ? (
                        <CheckCircleIcon sx={{color: "success.main", mr: 1}}/>
                    ) : (
                        <CancelIcon sx={{color: "error.main", mr: 1}}/>
                    )}
                    <Typography
                        variant="body1"
                        sx={{color: currentSeller.isValidate ? "success.main" : "error.main"}}
                    >
                        {currentSeller.isValidate ? "File is valid" : "File is invalid"}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box display="flex" alignItems="center">
                        <Typography
                            variant="body1"
                            sx={{fontWeight: 'bold', textDecoration: 'underline', mr: 1}}
                        >
                            Last Updated:
                        </Typography>
                        {currentSeller.updated ? (
                            <>
                                {(() => {
                                    const parsedDate = parseDateSafely(currentSeller.updated);
                                    const isValidDate = parsedDate !== null;
                                    const isTodayDate = isValidDate && isToday(parsedDate);
                                    return (
                                        <>
                                            <CalendarTodayIcon
                                                sx={{
                                                    fontSize: "1.2rem",
                                                    mr: 1,
                                                    color: isTodayDate ? "primary.main" : "error.main",
                                                }}
                                            />
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    color: isTodayDate ? "primary.main" : "error.main",
                                                }}
                                            >
                                                {isValidDate ? dateToStringFormat(parsedDate) : 'Invalid Date'}
                                            </Typography>
                                            {!isTodayDate && (
                                                <Typography variant="body1" sx={{color: "error.main", ml: 1}}>
                                                    (Not up to date!)
                                                </Typography>
                                            )}
                                        </>
                                    );
                                })()}
                            </>
                        ) : (
                            <>
                                <CalendarTodayIcon
                                    sx={{
                                        fontSize: "1.2rem",
                                        mr: 1,
                                        color: "error.main",
                                    }}
                                />
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: "error.main",
                                    }}
                                >
                                    N/A
                                </Typography>
                            </>
                        )}
                    </Box>
                    {action}
                </Box>
            </Grid>
           </>)
            }
        </Grid>
    );
}
export default SellerPageHeader;
